/* eslint-disable max-len */
import UseAxios from '../../../Api/http/http';
import {
  kpiPerformanceCycle,
} from '../../../Api/request/manageKpi';
import { fetchKpiDetails } from '../manageKpiUtil';


export const fetchKpiPerformanceCycleList = async () => {
  try {
    const response = await UseAxios(kpiPerformanceCycle());

    const kpiSetList = [];
    const nonKpiSetList = [];
    const currentDate = new Date();

    response.data.performanceCycleDetails.forEach((performance) => {
      const item = {
        id: performance.id,
        name: performance.cycleName,
      };

      if (performance.isKpiSet) {
        kpiSetList.push(item);
      }

      const endDate = new Date(performance.endDate);

      if (currentDate <= endDate) {
        nonKpiSetList.push(item);
      }
    });

    return { kpiSetList, nonKpiSetList };
  } catch (error) {
    return { kpiSetList: [], nonKpiSetList: [] };
  }
};

export const fetchPreviousKpiData = async ({
  verticalSelected, departmentSelected, designationSelected, previousPerformanceSelected,
  showImage, isSaveEnabled, setPreviousKpiDetails, setNoDataMessage,
}) => {
  if (showImage && isSaveEnabled) {
    try {
      const filter = {
        vertical: verticalSelected?.id,
        department: departmentSelected?.id,
        designation: designationSelected?.id,
        performancePeriod: previousPerformanceSelected[0]?.id,
      };

      const response = await fetchKpiDetails(filter);

      if (response.status === 200) {
        setPreviousKpiDetails(response.data.kpiDetails);
      } else {
        setNoDataMessage('No data available');
      }
    } catch (error) {
      console.error('Error fetching KPI details:', error);
      setPreviousKpiDetails({});
    }
  }
};
